export default "__VITE_ASSET__IwvTuRQz__"